import { render, staticRenderFns } from "./EResumoDisciplinas.vue?vue&type=template&id=90ab1448"
import script from "./EResumoDisciplinas.vue?vue&type=script&lang=js"
export * from "./EResumoDisciplinas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports